import AnalyticsContainer from './AnalyticsContainer';

export default AnalyticsContainer;
